import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock, Envelope, Headset, Phone } from '@sighten/beacon/icons';
import { Card } from 'shared/components/Card/Card';
import Text from 'shared/components/Text/Text';
import {
  ContactItem,
  ContactItemIcon,
  ContactItemContent,
  ContactItemLink,
  SupportContactCardContent,
} from './SupportContactCard.styles';

export function SupportContactCard() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'support&FAQs.faqCategories.agreementTransfer.sidebar',
  });

  const serviceHours = t('serviceHoursDetails').split('\n');

  return (
    <Card
      title="Support"
      icon={{
        element: <Headset size="lg" />,
        color: 'grey',
      }}
      width="100%"
    >
      <SupportContactCardContent>
        <ContactItem>
          <ContactItemIcon>
            <Phone size="sm" />
          </ContactItemIcon>
          <ContactItemContent>
            <Text as="h3">{t('phone')}</Text>
            <Text as="p">(877) 425-5201</Text>
          </ContactItemContent>
        </ContactItem>

        <ContactItem>
          <ContactItemIcon>
            <Envelope />
          </ContactItemIcon>
          <ContactItemContent>
            <Text as="h3">{t('email')}</Text>
            <ContactItemLink href="mailto:support@myeverbright.com">
              support@myeverbright.com
            </ContactItemLink>
          </ContactItemContent>
        </ContactItem>

        <ContactItem>
          <ContactItemIcon>
            <Clock />
          </ContactItemIcon>
          <ContactItemContent>
            <Text as="h3">{t('serviceHours')}</Text>
            {serviceHours.map((line) => (
              <Text as="p" key={line}>
                {line}
              </Text>
            ))}
          </ContactItemContent>
        </ContactItem>
      </SupportContactCardContent>
    </Card>
  );
}

export default SupportContactCard;
